var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"background-color":"#EFEFEF"}},[_c('HomeMar'),_c('ContactMar'),_c('FooterMar')],1)}
var staticRenderFns = []

export { render, staticRenderFns }